<template>
  <div class="product-search-results">
    <div class="container" @click="countAllResults">
      <table class="product-search-results-table">
        <thead>
          <tr class="search-head">
            <td></td>
            <td>Country</td>
            <td style="padding-left: 32px">Parent Manufacturer</td>
            <td>Manufacturer</td>
            <td>Product Name</td>
            <td>Reg. No</td>
            <td>Product Category</td>
            <td style="padding-left: 32px">Product Category(AUS)</td>
          </tr>
        </thead>
        <LoadAnimation
          v-if="this.$store.state.isProductLoading && this.isUser"
        />
        <tbody
          v-for="(searchResultByCountry, index) in searchResults"
          :key="index"
        >
          <tr
            v-for="searchResult in searchResultByCountry[1]"
            :key="searchResult._id"
            @click="removePrompt($event)"
          >
            <td class="checkbox-column">
              <label class="custom-check">
                <input
                  type="checkbox"
                  v-on:click="openDetailBox(searchResult, $event)"
                />
                <span class="checkmark"></span>
              </label>
            </td>
            <td v-if="searchResult.source">
              {{ getCountryFromSource(searchResult.source) }}
            </td>
            <td v-else style="text-align: center">-</td>
            <td v-if="searchResult.tags && searchResult.tags.manufacturer">
              <p class="d-flex align-items-center search-col-d">
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="search-inline-img"
                  alt="Asia Actual Logo"
                />{{ searchResult.tags.manufacturer }}
              </p>
            </td>
            <td v-else style="text-align: center">-</td>
            <td v-if="searchResult.manufacturerName">
              {{ searchResult.manufacturerName }}
            </td>
            <td v-else style="text-align: center">-</td>

            <td v-if="searchResult.productName">
              {{
                searchResult.productName
                  .replace(/ ï¿½ï¿½ï¿½/g, "ï¿½ï¿½ï¿½")
                  .replace(/ï¿½ï¿½ï¿½/g, "&trade;")
              }}
            </td>
            <td v-else style="text-align: center">-</td>

            <td v-if="searchResult.registrationNumber">
              {{ searchResult.registrationNumber }}
            </td>
            <td v-else style="text-align: left">-</td>

            <td v-if="searchResult.productCategory">
              {{ searchResult.productCategory }}
            </td>
            <td v-else style="text-align: center">-</td>
            <td v-if="searchResult.tags && searchResult.tags.productCategory && searchResult.tags.productCategory.length > 0">
              <p
                v-for="(pTag, index) in searchResult.tags.productCategory"
                :key="index"
                class="d-flex align-items-center search-col-d"
              >
                <img
                  src="@/assets/images/common/rose__meta_logo.png"
                  class="search-inline-img"
                  alt="Asia Actual Logo"
                />{{ pTag }}
              </p>
            </td>
            <td v-else style="text-align: center">-</td>
          </tr>
        </tbody>
      </table>
    </div>
    <SaveModal :searchRowItemData="searchRowItemData" @save="saveSearch" />
    <AvailableModal />
    <RegDataModal :regData="regData" :source="source" />
  </div>
</template>

<script>
import SearchResultDetail from "@/components/global/search-result-detail.vue";
import SaveModal from "@/components/user/modals/saveFromTable.vue";
import AvailableModal from "@/components/user/modals/non-available.vue";
import RegDataModal from "@/components/user/modals/reg-data.vue";
import SearchTag from "@/components/global/searchTag";

import { axiosClient } from "@/axios-client";
import LoadAnimation from "@/components/global/loadAnimation.vue";
import * as isUserLoggedIn from "@/store/isUserLoggedIn";

import singapore from "@/assets/images/components/flags/singapore.svg";
import malaysia from "@/assets/images/components/flags/malaysia.svg";
import thailand from "@/assets/images/components/flags/thailand.svg";
import hongKong from "@/assets/images/components/flags/hongKong.svg";
import usa from "@/assets/images/components/flags/usa.svg";
import philippines from "@/assets/images/components/flags/philippines.svg";
import indonesia from "@/assets/images/components/flags/indonesia.svg";

export default {
  name: "ProductSearchResults",
  components: {
    SearchResultDetail,
    SaveModal,
    LoadAnimation,
    AvailableModal,
    RegDataModal,
  },

  props: ["searchResults", "totalResultsCount"],

  created() {
    axiosClient.get("v1/account").then((response) => {
      this.currentUser = response.data;
    });
  },

  data() {
    return {
      counter: 0,
      searchRowItemData: {},
      currentUser: {},
      isUser: isUserLoggedIn.isUserLoggedIn(),
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      regData: {},
      source: null,
    };
  },

  methods: {
    openDetailBox(data, e) {
      this.$emit("select", data);
    },

    displayAllInCountry(e) {
      let tr = e.target.closest("tr");
      let additionalInfo = tr.nextSibling;

      tr.lastChild.firstChild.classList.toggle("active-btn");
      additionalInfo.style.display == "none"
        ? (additionalInfo.style.display = "table-row")
        : (additionalInfo.style.display = "none");
    },

    getCountryFromSource(source) {
      const sourceToCountry = {
        "Singapore HSA": "Singapore",
        "Philippines FDA": "Philippines",
        "Thailand FDA": "Thailand",
        USFDA: "United States",
        "Malaysia Medical Device Authority": "Malaysia",
        "Hong Kong MDD": "Hong Kong",
        "Indonesia PRKT": "Indonesia",
        "Australia ARTG": "Australia",
      };
      return sourceToCountry[source];
    },

    getCountryFlag(source) {
      const sourceToFlag = {
        "Singapore HSA": singapore,
        "Thailand FDA": thailand,
        "Malaysia Medical Device Authority": malaysia,
        "Philippines FDA": philippines,
        USFDA: usa,
        "Hong Kong MDD": hongKong,
        "Indonesia PRKT": indonesia,
      };
      return sourceToFlag[source];
    },

    displaySaveModal() {
      this.$emit("click", true);
    },

    displayLockedModal() {
      this.$emit("click", false);
    },

    removePrompt(e) {
      let inputs = document.querySelectorAll(
        ".product-search-results .checkbox-column input"
      );

      if (!e.target.closest(".checkbox-column")) {
        document.querySelector(".search-result-detail").style.display = "none";
        document.querySelector(
          ".product-search-results .container"
        ).style.overflow = "scroll";

        inputs.forEach((el) => {
          el.checked = false;
        });
      }
    },

    selectAllInputs() {
      let inputs = document.querySelectorAll(
        "table.product-search-results-table input"
      );
      this.counter++;

      for (let input of inputs) {
        if (this.counter % 2 == 1) {
          input.checked = true;
        } else {
          input.checked = false;
        }
      }
    },

    saveSearch(searchObject) {
      axiosClient
        .post("v1/search/registrations/saved-searches", {
          productName: searchObject.productName,
          productCategory: searchObject.productCategory,
          manufacturerName: searchObject.manufacturerName,
          specialty: searchObject.specialty,
          sources: searchObject.source,
          riskLevel: searchObject.riskLevel,
          resultsCount: "1",
        })
        .then((response) => console.log(response))
        .catch((err) => console.log(err));
    },

    createExpiryAlert(data) {
      if (!data.expirationDate) {
        document.querySelector(".available-modal-wrapper").style.opacity = "1";
        document.querySelector(".available-modal-wrapper").style.zIndex = "999";
        document
          .querySelector(".available-modal-wrapper")
          .classList.add("isModalOpen");
        document.querySelector("body").style.overflow = "hidden";
      } else {
        axiosClient.post("v1/alerts", {
          registrationId: data._id,
          numberOfMonthsPrior: 6,
        });
      }
    },

    clearFilters() {
      this.$emit("clearFilters");
    },

    countAllResults() {
      let numOfResults = 0;
      let results = this.searchResults;
      results.forEach((el) => {
        numOfResults += el[1].length;
      });

      return numOfResults;
    },

    isUserPremium() {
      if (this.currentUser.tier == "FREE") {
        return 0;
      } else {
        return 1;
      }
    },

    getDate(date) {
      let fullDate = new Date(date);
      let d = fullDate.getDate();
      let m = this.months[fullDate.getMonth()];
      let y = fullDate.getFullYear();
      return `${m} ${d}, ${y}`;
    },
  },
};
</script>

<style lang="scss">
.no-inline-img {
  margin-left: 32px;
}
.search-inline-img {
  padding-right: 10px;
  padding-bottom: 6px;
  width: 32px;
}
.search-col-d {
  position: relative;
}
.search-head {
  position: sticky;
  top: 0;
  background-color: #f9f9f9 !important;
  border: none !important;
  border-radius: 0 !important;
  z-index: 99;
}
.product-search-results-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;
  background-color: #f8f8f8;

  thead {
    tr {
      border-radius: 0px;
    }
    tr td {
      font-family: "Gotham-Medium";
      padding: 11px 10px;
      border-radius: 0px;

      &:first-of-type {
        padding-top: 0;
      }
    }
  }

  tbody {
    background-color: white;
    tr td {
      text-align: left;
      padding: 18px 10px;

      &:first-of-type {
        padding-left: 30px;
        padding-right: 30px;
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
      }

      &:nth-child(2) {
        width: 20%;
      }

      &:nth-child(4) {
        width: 11%;
      }

      &:nth-child(6) {
        width: 15%;
      }

      &:last-of-type {
        padding-right: 30px;
        border-top-right-radius: 15px;
        border-bottom-right-radius: 15px;
      }

      &:nth-child(3) {
        max-width: 300px;
      }
    }
  }
}
.product-search-results {
  margin-top: 35px;
  padding-bottom: 70px;

  .container {
    max-height: 70vh;
    overflow: scroll;
  }
}
</style>
